module.exports = __webpack_public_path__ + "static/media/23aa3c10-7b62-476d-818e-0db5613afb9e.c8a368b6.JPG";